const BulkNotificationSelectColumn = [
  {
    title: 'No.',
    dataIndex: 'index',
    sorter: (a, b) => a.index - b.index,
    width: 80
  },
  {
    title: 'Webpage URL',
    dataIndex: 'url',
    slot: 'url',
    width: 300
  },
  {
    title: 'Contact Group',
    slot: 'contact_group',
    sorter: (a, b) => ((a.contact_group && a.contact_group.description) || '').localeCompare((b.contact_group && b.contact_group.description) || ''),
    width: 200
  },
  {
    title: 'Notification Type',
    dataIndex: 'notification_type_name',
    slot: 'notification_type_name',
    width: 200
  }
];

export { BulkNotificationSelectColumn };
